import styled, { keyframes } from 'styled-components';


// Define keyframes for animation
const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const growBar = keyframes`
    from {
        width: 0;
    }
    to {
        width: 100%;
    }
`;

export const Container = styled.div`
    disply:flex;
    width:100%;
    overflow-y: auto;
    max-height: calc(75vh - 20px);
    padding-right:30px;
    padding-bottom:30px;

    @media (max-width: 768px) {
    max-height: 100%;
    overflow: auto; 
    width:100%;
    padding:16px 0;

  }
`;

export const RowContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
    animation: ${fadeIn} 1s ease-in-out;
    alignItems: center;

     @media (max-width: 768px) {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
`;

export const CardContainer = styled.div`
    display: flex;
    gap: 20px;
    animation: ${fadeIn} 1s ease-in-out;

    @media (max-width: 768px) {
     display: flex;
     flex-direction:column;
     width:100%;
  }
`;

export const CalH2 = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px 0;
  white-space: nowrap;
`;

export const NoteP = styled.p`
  font-size: 12px;
  font-weight: 400;
  margin-left:10px;
  color:rgb(102, 102, 102);
`;


export const ProgressBarAnimation = styled.div`
    height: 10px;
    background-color: #4caf50;
    animation: ${growBar} 3s ease-in-out;
`;

export const DropdownContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 16px;
  gap: 8px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-bottom: 16px;
    justify-content: flex-start; 
  }
`;


export const ModelLoadingWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
height: 100vh;
text-align: center;
opacity: ${(props) => (props.fadeOut ? 0 : 1)};
transition: opacity 0.6s ease;
`;

export const ModelRunner = styled.div`
model-viewer {
  animation: runAcross 2s linear infinite;
  width: 150px;
  height: 150px;
}

@keyframes runAcross {
  0% { transform: translateX(-100px); }
  100% { transform: translateX(100px); }
}

@media (max-width: 768px) {
  model-viewer {
    width: 100px;
    height: 100px;
  }
}
`;

export const ErrorWarp = styled.div`
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin:auto;
`;

export const ErrorImg = styled.img`
   width:150px;
`;
export const ErrorP = styled.h1`
    font-size: 18px;
    font-weight: bold;
    color: #61cbc9;
`;

export const LoadingText = styled.p`
  font-size: 20px;
  color: #61CBC9;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const StatValue = styled.span`
  font-size: 36px;
  font-weight: bold;
`;

export const StatUnit = styled.span`
  font-size: 24px;
  margin-left: 4px;
`;







